<template>
    <div class="chartBackClass">
        <div :ref="refName" :style="{ width, height }" id="barchartDom"></div>
        <div v-if="!showBool" class="noDataBackClass"> 
            <div class="noDataView">暂无数据，敬请期待</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        width: String,
        height: String,
        chartXArr: [],
        chartYArr: [],
        refName: String
    },
    data(){
        return{
            showBool: true
        }
    },
    watch:{
        chartXArr:{
            handler(){
                // this.chart.setOption(this.option);
                this.barInit();
            }
        }
    },
    // created(){
    //     setTimeout(() => {
    //         this.barInit()
    //     }, 800);
    // },
    methods: {
        barInit() {
            const {chartXArr, chartYArr} = this
            let yigenjin = chartYArr[2].data
            let weigenjin = chartYArr[3].data
            
            if(chartXArr.length > 0){
                this.showBool = true
                console.log('图表有数据----')
            }else{
                this.showBool = false
                console.log('图表没有数据111111')
            }

            // let sumNumber = [64, 58 * 2, 64 * 2, 64 * 2, 64 * 2, 25 * 2];

            let dom = 800;
            let barWidth = dom / 47;
            let manColors = [];
            let womanColors = [];

            for (let i = 0; i < 10; i++) {
                manColors.push({
                    type: 'linear',
                    x: 0,
                    x2: 1.5,
                    y: 0,
                    y2: 0,
                    colorStops: [{ offset: 0, color: '#FF6BE4' }, { offset: 1, color: '#FF03B0' }],
                });
                womanColors.push({
                    type: 'linear',
                    x: 0,
                    x2: 1.5,
                    y: 0,
                    y2: 0,
                    colorStops: [{ offset: 0, color: '#A0E9FF' }, { offset: 1, color: '#0073FF' }],
                });
            }
            let option = {
                // backgroundColor: '#010d3a',
                //提示框
                // legend: {
                //   x: 'right', // 可设定图例在左、右、居中
                //   y: 'top', // 可设定图例在上、下、居中
                //   padding:[0,50,0,0],
                // },
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        // var res = params[0].name + '<br/>'; // 添加标签名
                        // params.forEach(function (item) {
                        //     res += item.seriesName + ' : ' + item.value + '<br/>'; // 添加系列名和值
                        // });
                        // return res;
                        var res = params[0].seriesName + ': ' + params[0].value  + '<br/>' + 
                            params[3].seriesName + ': ' + params[3].value; // 添加标签名
                        return res;
                    },
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                /**区域位置*/
                grid: {
                    left: '16%',
                    right: '10%',
                    top: '10%',
                    bottom: '14%',
                },
                legend: {
                    top: '0',
                    right: '10',
                    textStyle: {
                        fontSize: 12,
                        color: '#FFFFFF'
                    },
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10, // 设置高度
                    itemGap: 12, // 设置间距
                    data: ['注册已跟进', '注册未跟进'],
                    color: ['#FF04B1', '#0275FF'],
                    // itemStyle: {
                    //     color: ['#FF04B1', '#0275FF'] // 设置所有图例标记的颜色为红色
                    // }
                },
                dataZoom: [
                    {
                        type: 'inside',
                        show: false,
                        start: 95,
                        end: 100
                    },
                    {
                        // show: false,
                        bottom: 0,
                        height: 20,
                        start: 0,
                        end: 100
                    }
                ],
                //X轴
                xAxis: {
                    data: chartXArr,
                    type: 'category',
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#053080',
                            width: 2,
                            shadowColor: '#053080',
                            shadowOffsetX: '20',
                        },
                        symbol: ['none'],
                        symbolOffset: [0, 25],
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: true,
                        inside: true,
                        interval: 'auto', // 控制刻度的显示间隔，0 表示显示所有刻度
                        alignWithLabel: true, // 刻度与标签对齐
                        lineStyle: {
                            color: '#30D0FF',
                            width: "2",
                        },
                    },
                    axisLabel: {
                        margin: 10,
                        interval: 0,
                        textStyle: {
                            color: '#fff',  
                        }
                    },
                },
                yAxis: {
                    show: true,
                    splitNumber: 6,
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: '#053080',
                        },
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                        margin: 10,
                        fontSize: 15,
                        formatter: function (value) {
                            // return value + 'w';
                            return value;
                        }
                    },
                },
                series: [
                    {
                        name: '注册已跟进',
                        type: 'bar',
                        barWidth: barWidth,
                        itemStyle: {
                            color: '#FF04B1' // 设置所有图例标记的颜色为红色
                            // normal: {
                            //     color: function (params) {
                            //         return manColors[params.dataIndex % 37];
                            //     },
                            // },
                        },
                        data: yigenjin,
                    },
                    {
                        z: 2,
                        type: 'pictorialBar',
                        data: yigenjin,
                        symbol: 'diamond',
                        symbolOffset: ['-63%', '50%'],
                        symbolSize: [barWidth, barWidth * 0.1],
                        itemStyle: {
                            color: '#FF04B1' // 设置所有图例标记的颜色为红色
                            // normal: {
                            //     color: function (params) {
                            //         return manColors[params.dataIndex % 7];
                            //     },
                            // },
                        },
                    },
                    {
                        z: 3,
                        type: 'pictorialBar',
                        symbolPosition: 'end',
                        data: yigenjin,
                        symbol: 'diamond',
                        symbolOffset: ['-63%', '-50%'],
                        symbolSize: [barWidth, barWidth * 0.5],
                        itemStyle: {
                            color: '#FF04B1' // 设置所有图例标记的颜色为红色
                            // normal: {
                            //     borderWidth: 0,
                            //     color: function (params) {
                            //         return manColors[params.dataIndex % 7].colorStops[0].color;
                            //     },
                            // },
                        },
                    },
                    // ---------------------分割线---------------------
                    {
                        name: '注册未跟进',
                        type: 'bar',
                        barWidth: barWidth,
                        itemStyle: {
                            color: '#0073FF',
                            // normal: {
                            //     color: function (params) {
                            //         return womanColors[params.dataIndex % 7];
                            //     },
                            // },
                        },
                        data: weigenjin,
                    },
                    {
                        z: 2,
                        type: 'pictorialBar',
                        data: weigenjin,
                        symbol: 'diamond',
                        symbolOffset: ['63%', '50%'],
                        symbolSize: [barWidth, barWidth * 0.5],
                        itemStyle: {
                            color: '#0073FF',

                            // normal: {
                            //     color: function (params) {
                            //         return womanColors[params.dataIndex % 7];
                            //     },
                            // },
                        },
                    },
                    {
                        z: 3,
                        type: 'pictorialBar',
                        symbolPosition: 'end',
                        data: weigenjin,
                        symbol: 'diamond',
                        symbolOffset: ['63%', '-50%'],
                        symbolSize: [barWidth, barWidth * 0.5],
                        itemStyle: {
                            color: '#0073FF',
                            // normal: {
                            //     borderWidth: 0,
                            //     color: function (params) {
                            //         return womanColors[params.dataIndex % 7].colorStops[0].color;
                            //     },
                            // },
                        },
                    },

                // 总人数
                // {
                //   name: '总人数',
                //   type: 'line',
                //   showAllSymbol: false,
                //   symbol: 'circle',
                //   symbolSize: 10,
                //   itemStyle: {
                //     color: '#fff',
                //     shadowColor: '#5ce0e2',
                //     shadowBlur: 20,
                //     borderColor: '#5ce0e2',
                //     borderWidth: 5,
                //   },
                //   lineStyle: {
                //     width: 4,
                //     color: '#5ce0e2',
                //     shadowColor: '#5ce0e2',
                //     shadowBlur: 20,
                //   },
                //   data: sumNumber,
                // },
                ],
            };
            // this.chart = echarts.init(this.$refs[this.refName]);

            const myChart = echarts.init(this.$refs[this.refName]);
            myChart.setOption(option);
            window.addEventListener("resize", () => {
                // 调用 echartsInstance.resize 改变图表的大小
                myChart.resize();
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.chartBackClass{
    position: relative;
    width: 100%;
    height: 100%;
    // background-color: #FFFFFF;
}
.noDataBackClass{
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 100%;
    z-index: 100;
    // background-color: #131D27;
}
.noDataView{
    margin: auto;
    width: 180px;
    height: 40px;
    line-height: 40px;
    border-radius: 9px;
    background: #30D0FF50;
    font-weight: 600;
    font-size: 16px;
    text-shadow: 0px 1px 2px rgba(0,0,0,0.5);
    color: #FFFFFF;
    text-align: center;
}
</style>